import { useAppState } from "@/modules/app/useAppContext";
import { getMoneySavings } from "../../../utils";

interface MoneySavingsCellProps {
  savings: {
    min: number;
    max: number;
  } | null;
}

export const MoneySavingsCell = ({ savings }: MoneySavingsCellProps) => {
  const { currency } = useAppState();

  return (
    <div className={"al-px-2 al-text-dark-gray al-text-sm al-font-normal al-leading-5"}>
      {getMoneySavings(String(savings?.min ?? 0), String(savings?.max ?? 0), currency)}
    </div>
  );
};
